

<div class="container" *ngIf="subscriptionbillingUtility.toi !='toi' && !subscriptionbillingUtility?.rescheduleExamData?.couponDetails?.isCouponApplied">
  <div class="partpayment-section">

    <div class="subscription-heading-area">
      <h3 class="section-heading">Complete Payment</h3>
    </div>

  <!-- new flow start -->
  <div class="SUBCRP-cart-package-area">
    <div class="row mob-reverse">
      <div class="col-xl-8 col-lg-7 col-md-12 left-col">
        <!-- <div class="SUBCRP-cart-address-box desktop-address">
          <div class="SUBCRP-cart-address-cnt-area">
            <ng-container *ngTemplateOutlet="orderReview_billingSummery_couponCode"></ng-container>
          </div>
        </div> -->

        <div class="hide-bilingsummary">
          <ng-container *ngTemplateOutlet="orderReview_billingSummery_couponCode"></ng-container>
        </div>

        <!-- custom payment flow area open -->
        <div class="subscription-cstm-pymnt-area">
          <div class="subscription-pymnt-typ-lst-area subscrp-brdr-frmbx"
            [ngClass]="{'mobPaymntTypeLstClosed':customPaymntPanelStatus}">
            <div class="subscrp-brdr-frmbx-hdr">Select Payment Method</div>
            <ul class="subscrp-pymnt-typ-lst">
              <li class="list-row">
                <label class="label">
                  <input type="radio" name="custom-payment-type" class="label-input" value="card"
                    [checked]="customPaymntType =='card'" (click)="customPaymntTypeEvent('card')" />
                  <div class="subscrp-pymnt-list-box"
                    [ngClass]="{'mob-sltd-pymnt-lstbx':customPaymntType =='card' && customPaymntPanelStatus == true}">
                    <img src="assets/img/custom-payment-icons/creditcard123.svg" class="subscrp-pymnt-icn" />
                    <div class="subscrp-pymnt-info">
                      <h3 class="subscrp-pymnt-title">Card</h3>
                      <!-- <h4 class="subscrp-pymnt-discunttitle" *ngIf="paymentType=='fullpayment' && subscriptionbillingUtility.fullPaymentOptions?.discountPer">Extra {{subscriptionbillingUtility.fullPaymentOptions?.discountPer}}% discount</h4> -->
                    </div>
                  </div>
                </label>
              </li>
              <li class="list-row">
                <label class="label">
                  <input type="radio" name="custom-payment-type" value="net_banking" class="label-input"
                    (click)="customPaymntTypeEvent('net_banking')" [checked]="customPaymntType =='net_banking'" />
                  <div class="subscrp-pymnt-list-box"
                    [ngClass]="{'mob-sltd-pymnt-lstbx':customPaymntType =='net_banking' && customPaymntPanelStatus == true}">
                    <img src="assets/img/custom-payment-icons/netbanking.svg" class="subscrp-pymnt-icn" />
                    <div class="subscrp-pymnt-info">
                      <h3 class="subscrp-pymnt-title">Net Banking</h3>
                      <!-- <h4 class="subscrp-pymnt-discunttitle" *ngIf="paymentType=='fullpayment' && subscriptionbillingUtility.fullPaymentOptions?.discountPer">Extra {{subscriptionbillingUtility.fullPaymentOptions?.discountPer}}% discount</h4> -->
                    </div>
                  </div>
                </label>
              </li>
              <li class="list-row">
                <label class="label">
                  <input type="radio" name="custom-payment-type" value="upi" class="label-input"
                    (click)="customPaymntTypeEvent('upi')" [checked]="customPaymntType =='upi'" />
                  <div class="subscrp-pymnt-list-box"
                    [ngClass]="{'mob-sltd-pymnt-lstbx':customPaymntType =='upi' && customPaymntPanelStatus == true}">
                    <img src="assets/img/custom-payment-icons/upi.svg" class="subscrp-pymnt-icn" />
                    <div class="subscrp-pymnt-info">
                      <h3 class="subscrp-pymnt-title">UPI/QR</h3>
                      <!-- <h4 class="subscrp-pymnt-discunttitle" *ngIf="paymentType=='fullpayment' && subscriptionbillingUtility.fullPaymentOptions?.discountPer">Extra {{subscriptionbillingUtility.fullPaymentOptions?.discountPer}}% discount</h4> -->
                    </div>
                  </div>
                </label>
              </li>
              <li class="list-row">
                <label class="label">
                  <input type="radio" name="custom-payment-type" value="wallet" class="label-input"
                    (click)="customPaymntTypeEvent('wallet')" [checked]="customPaymntType =='wallet'" />
                  <div class="subscrp-pymnt-list-box"
                    [ngClass]="{'mob-sltd-pymnt-lstbx':customPaymntType =='wallet' && customPaymntPanelStatus == true}">
                    <img src="assets/img/custom-payment-icons/Wallet.svg" class="subscrp-pymnt-icn" />
                    <div class="subscrp-pymnt-info">
                      <h3 class="subscrp-pymnt-title">Wallet</h3>
                      <!-- <h4 class="subscrp-pymnt-discunttitle" *ngIf="paymentType=='fullpayment' && subscriptionbillingUtility.fullPaymentOptions?.discountPer">Extra {{subscriptionbillingUtility.fullPaymentOptions?.discountPer}}% discount</h4> -->
                    </div>
                  </div>
                </label>
              </li>
              <!-- <li class="list-row" *ngIf="paymentType=='fullpayment' && ((bajajFinanceNoCostEmiData?.showBajaj && bajajFinanceNoCostEmiData?.min_amount<=subscriptionbillingUtility.emiPayLaterFulltotalAmount && subscriptionbillingUtility.emiPayLaterFulltotalAmount<=bajajFinanceNoCostEmiData?.max_amount) || showWalnut369 || hasDebitCardEMI || hasCreditCardEMI)">
                <label class="label">
                  <input type="radio" name="custom-payment-type" value="emi" class="label-input" (click)="customPaymntTypeEvent('emi')" [checked]="customPaymntType =='emi'" />
                  <div class="subscrp-pymnt-list-box" [ngClass]="{'mob-sltd-pymnt-lstbx':customPaymntType =='emi' && customPaymntPanelStatus == true}">
                    <img src="assets/img/custom-payment-icons/EMI.svg" class="subscrp-pymnt-icn" />
                    <div class="subscrp-pymnt-info">
                      <h3 class="subscrp-pymnt-title">EMI</h3>
                    </div>
                  </div>
                </label>
              </li> -->
              <!-- <li class="list-row" *ngIf="subscriptionbillingUtility.emiOptions?.length && paymentType=='fullpayment'">
                <label class="label">
                  <input type="radio" name="custom-payment-type" value="pay_in_part" class="label-input"
                    (click)="customPaymntTypeEvent('pay_in_part')" [checked]="customPaymntType =='pay_in_part'" />
                  <div class="subscrp-pymnt-list-box"
                    [ngClass]="{'mob-sltd-pymnt-lstbx':customPaymntType =='pay_in_part' && customPaymntPanelStatus == true}">
                    <img src="assets/img/custom-payment-icons/pay-in-part.svg" class="subscrp-pymnt-icn" />
                    <div class="subscrp-pymnt-info">
                      <h3 class="subscrp-pymnt-title">Pay in Parts</h3>
                    </div>
                  </div>
                </label>
              </li> -->
              <!-- <li class="list-row" *ngIf="paymentType=='fullpayment'">
                <label class="label">
                  <input type="radio" name="custom-payment-type" value="pay_later" class="label-input"
                    (click)="customPaymntTypeEvent('pay_later')" [checked]="customPaymntType =='pay_later'" />
                  <div class="subscrp-pymnt-list-box"
                    [ngClass]="{'mob-sltd-pymnt-lstbx':customPaymntType =='pay_later' && customPaymntPanelStatus == true}">
                    <img src="assets/img/custom-payment-icons/pay-later.svg" class="subscrp-pymnt-icn" />
                    <div class="subscrp-pymnt-info">
                      <h3 class="subscrp-pymnt-title">Pay Later</h3>
                    </div>
                  </div>
                </label>
              </li> -->
            </ul>
          </div>
          <div class="subscription-pymnt-detl-pnls-wrap" [ngClass]="{'mobPaymntPanelOpened':customPaymntPanelStatus}">
            <div class="subscrp-brdr-frmbx">
              <div class="subscrp-brdr-frmbx-hdr brd-btm m-hide">
                <div class="brdr-frmbx-desk-hdng">Select Payment Method</div>
              </div>
              <!-- card panel open -->
              <div *ngIf="customPaymntType =='card'">
                <div class="subscrp-brdr-frmbx-cntarea">
                  <h3 class="subscrp-sctn-hdng" [ngClass]="{'hideInMobile': innerPanelName == 'addNewCard'}"
                    (click)="customPaymntPanelClose()" *ngIf="paymentType=='fullpayment' || deviceWidth<=1200">
                    <button class="icn-btn desk-hide">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </button> Credit / Debit Card
                  </h3>
                  <h3 class="subscrp-sctn-hdng desk-below-hide" (click)="goToPayInPartsMenu()" *ngIf="paymentType=='partpayment'">
                    <button class="icn-btn">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </button> Pay in Parts
                  </h3>
                  <!-- <div class="existing-crd-sctn" *ngIf="innerPanelName == ''">
                    <ul class="existing-crd-list">
                      <li class="li-crd-row">
                        <label class="li-crd-label">
                          <input type="radio" name="cards" class="li-crd-input" />
                          <div class="existing-crd-box">
                            <img class="crd-tick-icn" src="assets/img/custom-payment-icons/blue-border-tick.svg" />
                            <div class="bnk-icn-box"></div>
                            <div class="bnk-crd-info-col">
                              <ul class="crd-info-list">
                                <li class="crd-info-row">
                                  <span class="crd-title">Personal</span>
                                  <span class="crd-detl"><b>541919XXXXXX2088</b></span>
                                </li>
                                <li class="crd-info-row cvv-row">
                                  <span class="crd-title">Enter CVV</span>
                                  <div class="crd-detl"><input type="password" class="cvv-field" /></div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </label>
                      </li>
                      <li class="li-crd-row">
                        <label class="li-crd-label">
                          <input type="radio" name="cards" class="li-crd-input" />
                          <div class="existing-crd-box">
                            <img class="crd-tick-icn" src="assets/img/custom-payment-icons/blue-border-tick.svg" />
                            <div class="bnk-icn-box"></div>
                            <div class="bnk-crd-info-col">
                              <ul class="crd-info-list">
                                <li class="crd-info-row">
                                  <span class="crd-title">Personal</span>
                                  <span class="crd-detl"><b>541919XXXXXX2088</b></span>
                                </li>
                                <li class="crd-info-row cvv-row">
                                  <span class="crd-title">Enter CVV</span>
                                  <div class="crd-detl"><input type="password" class="cvv-field" /></div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </label>
                      </li>
                      <li class="li-crd-row">
                        <label class="li-crd-label">
                          <input type="radio" name="cards" class="li-crd-input" />
                          <div class="existing-crd-box">
                            <img class="crd-tick-icn" src="assets/img/custom-payment-icons/blue-border-tick.svg" />
                            <div class="bnk-icn-box"></div>
                            <div class="bnk-crd-info-col">
                              <ul class="crd-info-list">
                                <li class="crd-info-row">
                                  <span class="crd-title">Personal</span>
                                  <span class="crd-detl"><b>541919XXXXXX2088</b></span>
                                </li>
                                <li class="crd-info-row cvv-row">
                                  <span class="crd-title">Enter CVV</span>
                                  <div class="crd-detl"><input type="password" class="cvv-field" /></div>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </label>
                      </li>
                      
                      <li class="li-crd-row">
                        <label class="li-crd-label" (click)="toggleInnerPanel('addNewCard')">
                          <input type="radio" name="cards" class="li-crd-input" />
                          <div class="existing-crd-box normal">
                            <img class="crd-tick-icn" src="assets/img/custom-payment-icons/blue-border-tick.svg" />
                            <div class="bnk-crd-info-col">
                              <ul class="crd-info-list">
                                <li class="crd-info-row">
                                  <span class="crd-detl">Add Debit / Credit / ATM Card</span>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </label>
                      </li>
                    </ul>
                    <div class="subscrp-pymnt-pnl-actnarea">
                      <button class="pymnt-blue-btn">Pay <span class="rupee">₹</span>50,350 using this card</button>
                    </div>
                  </div> -->
                  <div class="subscrp-add-crd-box">
                    <!-- *ngIf="innerPanelName == 'addNewCard'" -->
                    <div class="subscrp-add-crd-hdr-area justify-content-between">
                      <h4 class="subscrp-add-crd-hdng">
                        <!-- <i class="fa fa-angle-left" aria-hidden="true"></i>  -->
                        Enter Debit / Credit / ATM Card
                      </h4>
                      <!-- <button class="subscrp-cls-btn" (click)="toggleInnerPanel('')"><img src="assets/img/detail-close-icon.svg" /></button> -->
                    </div>
                    <div class="subscrp-form-area" [formGroup]="newCardForm">
                      <div class="subscrp-add-crd-fld-row">
                        <input type="text" class="subscrp-add-crd-fld" placeholder="Name on Card"
                          formControlName='card_placeholder_name'
                          OnlyAlphabetsAndSpace
                          onkeypress="return (event.charCode>= 65 && event.charCode<=90) || (event.charCode>= 97 && event.charCode<=122) || event.charCode==32"
                        />
                        <span *ngIf="newCardForm?.controls?.card_placeholder_name?.touched">
                          <span class="text-danger error-text"
                            *ngIf="newCardForm?.controls?.card_placeholder_name?.errors?.required">
                            *Please Enter name
                          </span>
                          <span class="text-danger error-text" *ngIf="newCardForm?.controls?.card_placeholder_name?.errors?.pattern">
                            *Please Provide correct name
                          </span>
                        </span>
                      </div>
                      <div class="subscrp-add-crd-fld-row">
                        <input type="text" class="subscrp-add-crd-fld" placeholder="Card Number"
                          maxlength="19"
                          formControlName='card_number' onlyNumber />
                        <span *ngIf="newCardForm?.controls?.card_number?.touched">
                          <span class="text-danger error-text"
                            *ngIf="newCardForm?.controls?.card_number?.errors?.required">
                            *Please Enter card number
                          </span>
                          <p class="text-danger error-text" *ngIf="newCardForm?.controls?.card_number?.errors?.pattern">
                            *Please Provide correct card number
                          </p>
                        </span>
                      </div>
                      <div class="subscrp-add-crd-fld-row">
                        <div class="row custom-row">
                          <div class="col-7 custom-col">
                            <input type="text" class="subscrp-add-crd-fld" placeholder="Expiry Date (MM/YY)"
                              name="expiryAutofillDoesntKnow"
                              autocomplete="noac"
                              formControlName='expiry' maxlength='5'
                              (keypress)="dateKeyPress($event)"
                              (keyup)="addSlash($event)"
                              (keydown)="removeSlash($event)"
                            />
                            <span *ngIf="newCardForm?.controls?.expiry?.touched">
                              <span class="text-danger error-text"
                                *ngIf="newCardForm?.controls?.expiry?.errors?.required">
                                *Please Enter expiry date
                              </span>
                              <span class="text-danger error-text"
                                *ngIf="newCardForm?.controls?.expiry?.errors?.pattern">
                                *Please Provide correct expiry date(MM/YY)
                              </span>
                              <span class="text-danger error-text"
                                *ngIf="!newCardForm?.controls?.expiry?.errors?.required && !newCardForm?.controls?.expiry?.errors?.pattern && newCardForm?.controls?.expiry?.errors?.cardExpiryCheck">
                                *Card expiry date is over
                              </span>
                            </span>
                          </div>
                          <div class="col-5 custom-col">
                            <input type="password" class="subscrp-add-crd-fld" placeholder="CVV"
                              maxlength='4'
                              name="cvvAutofillDoesntKnow"
                              autocomplete="noac"
                              formControlName='cvv'
                              onkeypress="return event.charCode>= 48 && event.charCode<=57"
                              onlyNumber
                            />
                            <span *ngIf="newCardForm?.controls?.cvv?.touched">
                              <span class="text-danger error-text" *ngIf="newCardForm?.controls?.cvv?.errors?.required">
                                *Please Enter cvv
                              </span>
                              <span class="text-danger error-text" *ngIf="newCardForm?.controls?.cvv?.errors?.pattern">
                                *Please Provide correct cvv
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div class="subscrp-add-crd-actn-area">
                        <!-- <button class="pymnt-blue-btn full-width" [disabled]="!newCardForm.valid" (click)="addCard()">Pay <span class="rupee">₹</span>{{subscriptionbillingUtility.fulltotalAmount | number : '1.2-2'}} using this card</button> -->
                        <button class="pymnt-blue-btn full-width" [disabled]="!newCardForm.valid && subscriptionbillingUtility.emiPayLaterFulltotalAmount"
                          (click)="addCard()">Pay <span class="rupee">₹</span>
                          {{paymentType == "fullpayment" ? (subscriptionbillingUtility.fullPaymentOptions?.amount | number : '1.2-2') :
                          (((subscriptionbillingUtility.emiOptions?.length)?(subscriptionbillingUtility.emiOptions[0].amount):0) | number :'1.2-2')}} using Card</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- card panel closed -->

              <!-- Net Banking panel open -->
              <div *ngIf="customPaymntType =='net_banking'">
                <div class="subscrp-brdr-frmbx-cntarea">
                  <h3 class="subscrp-sctn-hdng" (click)="customPaymntPanelClose()" *ngIf="paymentType=='fullpayment' || deviceWidth<=1200">
                    <button class="icn-btn desk-hide">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </button> Netbanking</h3>
                  <h3 class="subscrp-sctn-hdng desk-below-hide" (click)="goToPayInPartsMenu()" *ngIf="paymentType=='partpayment'">
                    <button class="icn-btn">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </button> Pay in Parts
                  </h3>
                  <div [formGroup]="bankControlForm">
                    <div class="netbanking-list-drpdwn">
                      <img src="assets/img/search-icon-dark.svg" class="bnk-srch-icn" />
                      <i class="fa fa-caret-down bnk-dwn-arrow"></i>
                      <input type="text" class="netbanking-search-fld" placeholder="Search for a bank" matInput
                        [matAutocomplete]="auto" formControlName="bankName" (focus)="selectedBankName=''">
                      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                          {{option.name}}
                        </mat-option>
                      </mat-autocomplete>
                    </div>
                  </div>
                  <div class="subscrp-net-bnk-area">
                    <ul class="subscrp-net-bnk-lst">
                      <li class="subscrp-net-bnk-li" *ngFor="let bank of popularBanks; let i=index"
                        (click)="selectedBank(bank.code)">
                        <label class="subscrp-net-bnk-label" *ngIf="i<6">
                          <input type="radio" class="subscrp-net-bnk-radio" name="bankName"
                            [checked]="selectedBankName==bank.code" />
                          <div class="subscrp-net-bnk-bx">
                            <div class="bank-icn-holdr"><img
                                src="assets/img/custom-payment-icons/{{bank.code}}-bank.png" class="bank-icn" /></div>
                                <span class="bank-tick-icn-wrap">
                                  <img class="bank-tick-icn" src="assets/img/custom-payment-icons/blue-border-tick-2.svg" />
                                </span>
                            <h4 class="subscrp-net-bnk-title">{{ bank.name }}</h4>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="subscrp-pymnt-pnl-actnarea">
                    <button class="pymnt-blue-btn"
                      [disabled]="(!bankControlForm?.valid || !bankControlForm?.controls?.bankName?.value) && !selectedBankName && subscriptionbillingUtility.emiPayLaterFulltotalAmount"
                      (click)="payUsingNetBank()">Pay <span class="rupee">₹</span>
                      {{paymentType == "fullpayment" ? (subscriptionbillingUtility.fullPaymentOptions?.amount | number : '1.2-2') :
                      (((subscriptionbillingUtility.emiOptions?.length)?(subscriptionbillingUtility.emiOptions[0].amount):0) | number :'1.2-2')}} using Net banking</button>
                  </div>
                </div>
              </div>
              <!-- Net Banking panel closed -->

              <!-- UPI panel open -->
              <div *ngIf="customPaymntType =='upi'">
                <div class="subscrp-brdr-frmbx-cntarea">
                  <div class="payViaUPI-panel" *ngIf="innerPanelName == ''">
                    <h3 class="subscrp-sctn-hdng" (click)="customPaymntPanelClose()" *ngIf="paymentType=='fullpayment' || deviceWidth<=1200">
                      <button class="icn-btn desk-hide"><i class="fa fa-angle-left" aria-hidden="true"></i></button> Pay
                      via UPI
                    </h3>
                    <h3 class="subscrp-sctn-hdng desk-below-hide" (click)="goToPayInPartsMenu()" *ngIf="paymentType=='partpayment'">
                      <button class="icn-btn">
                        <i class="fa fa-angle-left" aria-hidden="true"></i>
                      </button> Pay in Parts
                    </h3>
                    <div class="subscrp-blue-brdbox">
                      <div class="subscrp-blue-brdbox-hdr">
                        <h3 class="subscrp-blue-hdng">Enter UPI ID</h3>
                      </div>
                      <ul class="subscrp-upi-logo-area">
                        <li><img src="assets/img/gpay.svg" class="upi-icn" /></li>
                        <li><img src="assets/img/phonepe.svg" class="upi-icn" /></li>
                        <li><img src="assets/img/paytm.svg" class="upi-icn" /></li>
                        <li><img src="assets/img/bhim.svg" class="upi-icn" /></li>
                      </ul>
                      <div class="subscrp-upi-fld-area" [formGroup]="UPIControlForm">
                        <div class="subscrp-upi-fld-wrap">
                          <input type="text" class="subscrp-upi-input-fld" placeholder="example@upi"
                            formControlName="vpa" />
                          <label *ngIf="!upicheckLoading && isUPIVerified && isUPIValid" class="green-text">Verified succesfully</label>
                          <label *ngIf="!upicheckLoading && isUPIVerified && !isUPIValid" class="subscrp-upi-error">Invalid VPA. Please enter a valid Virtual Payment Address</label>
                          <span *ngIf="UPIControlForm?.controls?.vpa?.touched">
                            <span class="text-danger error-text"
                              *ngIf="UPIControlForm?.controls?.vpa?.errors?.required">
                              *Please Enter vpa
                            </span>
                            <span class="text-danger error-text" *ngIf="UPIControlForm?.controls?.vpa?.errors?.pattern">
                              *Please Provide correct vpa
                            </span>
                          </span>
                        </div>
                        <button class="subscrp-upi-btn" 
                          [disabled]="isUPIValid || UPIControlForm?.controls?.vpa?.errors?.required || UPIControlForm?.controls?.vpa?.errors?.pattern"
                          (click)="checkIsUPICorrect()">VERIFY</button>
                      </div>
                    </div>
                    <div class="subscrp-blue-brdbox" *ngIf="deviceWidth>=576">
                      <div class="subscrp-blue-brdbox-hdr">
                        <h3 class="subscrp-blue-hdng">Pay using QR code</h3>
                      </div>
                      <ul class="subscrp-nrmal-v-list">
                        <li>
                          <div class="subscrp-blue-bg-brdbox pointer" (click)="payUsingUPI('QR')">
                            <!-- (click)="toggleInnerPanel('payViaQRCode')" -->
                            <div class="subscrp-info-col">
                              <img class="subscrp-blue-icn" src="assets/img/custom-payment-icons/qrcode-icon.svg" />
                              <div class="subscrp-bx-info">
                                <h3 class="hdng">Show QR Code</h3>
                                <h4 class="subhdng">Scan the QR code using your UPI app</h4>
                              </div>
                            </div>
                            <div class="subscrp-actn-col">
                              <div class="icn-btn"><i class="fa fa-angle-right icn"></i></div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="subscrp-pymnt-pnl-actnarea">
                      <button class="pymnt-blue-btn mid-width" [disabled]="(!isUPIValid || !isUPIVerified) && subscriptionbillingUtility.emiPayLaterFulltotalAmount" 
                        (click)="payUsingUPI('UPI')">Pay <span class="rupee">₹</span>
                        {{paymentType == "fullpayment" ? (subscriptionbillingUtility.fullPaymentOptions?.amount | number : '1.2-2')
                        : (((subscriptionbillingUtility.emiOptions?.length)?(subscriptionbillingUtility.emiOptions[0].amount):0) | number :'1.2-2')}} using UPI</button>
                    </div>
                  </div>
                  <div class="payViaQRCode-panel" *ngIf="innerPanelName == 'payViaQRCode'">
                    <h3 class="subscrp-sctn-hdng" (click)="toggleInnerPanel('')">
                      <button class="icn-btn desk-hide"><i class="fa fa-angle-left"></i></button> Pay via QR Code
                    </h3>
                    <div class="subscrp-QRCode-area">
                      <p class="subscrp-QRCode-txt">Scan the QR code from your phone. Use any
                        UPI app such as BHIM, Phonepe, Google pay etc.</p>
                      <img src="assets/img/QR-Code.svg" class="QRCode-scan-icn" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- UPI panel closed -->

              <!-- Wallet panel open -->
              <div *ngIf="customPaymntType =='wallet'">
                <div class="subscrp-brdr-frmbx-cntarea">
                  <h3 class="subscrp-sctn-hdng" (click)="customPaymntPanelClose()" *ngIf="paymentType=='fullpayment' || deviceWidth<=1200">
                    <button class="icn-btn desk-hide"><i class="fa fa-angle-left" aria-hidden="true"></i></button> <span
                      class="d-hide">Pay via &nbsp;</span>Wallets
                  </h3>
                  <h3 class="subscrp-sctn-hdng desk-below-hide" (click)="goToPayInPartsMenu()" *ngIf="paymentType=='partpayment'">
                    <button class="icn-btn">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </button> Pay in Parts
                  </h3>
                  <div>

                    <div class="subscrp-wallet-carousel-area">
                      <carousel class="subscrp-wallet-carousel" #myCarousel [margin]="10" [cellWidth]="120"
                        [overflowCellsLimit]="2">
                        <div class="carousel-cell" *ngFor="let wallet of wallets" (click)="selectedWallet(wallet.code)">
                          <label class="subscrp-wallet-label pointer">
                            <input type="radio" name="walletname" class="subscrp-wallet-radio"
                              [checked]="selectedWalletCode == wallet.code" />
                            <div class="subscrp-wallet-bx">
                              <img class="wallet-tick-icn" src="assets/img/custom-payment-icons/blue-border-tick.svg" />
                              <div class="wallet-top-prt-area">
                                <div class="wallet-icn-holdr"><img
                                    src="assets/img/custom-payment-icons/{{wallet?.code}}-wallet.png"
                                    class="wallet-icn" /></div>
                                <h3 class="subscrp-wallet-title">{{ wallet?.name | titlecase }}</h3>
                              </div>
                            </div>
                          </label>
                        </div>
                        <!-- <div class="carousel-cell">
                          <label class="subscrp-wallet-label pointer">
                            <input type="radio" name="walletname" class="subscrp-wallet-radio" />
                            <div class="subscrp-wallet-bx linked">
                              <img class="wallet-tick-icn" src="assets/img/custom-payment-icons/blue-border-tick.svg" />
                              <div class="wallet-top-prt-area">
                                <div class="wallet-icn-holdr"><img src="assets/img/paytm.svg" class="wallet-icn" /></div>
                                <h3 class="subscrp-wallet-title">Paytm</h3>
                              </div>
                              <h4 class="subscrp-wallet-price-txt">
                                <span class="rupee-txt">₹</span> 0.00
                              </h4>
                            </div>
                          </label>
                        </div>
                        <div class="carousel-cell">
                          <label class="subscrp-wallet-label pointer">
                            <input type="radio" name="walletname" class="subscrp-wallet-radio" />
                            <div class="subscrp-wallet-bx">
                              <img class="wallet-tick-icn" src="assets/img/custom-payment-icons/blue-border-tick.svg" />
                              <div class="wallet-top-prt-area">
                                <div class="wallet-icn-holdr"><img src="assets/img/freeCharge.svg" class="wallet-icn" /></div>
                                <h3 class="subscrp-wallet-title">FreeCharge</h3>
                              </div>
                              <button class="subscrp-wallet-link">LINK</button>
                            </div>
                          </label>
                        </div> -->
                      </carousel>
                    </div>

                    <!-- <div class="subscrp-wallet-form-area">
                      <h3 class="wallet-form-hdng">Recharge your PayTm wallet to pay for your order</h3>
                      <div class="wallet-form-area">
                        <div class="row">
                          <div class="col-12">
                            <div class="wallet-fld">
                              <span class="rupee-txt fld-icn">₹</span>
                              <input type="text" class="wallet-text-fld price-text-fld" placeholder="" value="1,00,000" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="subscrp-wallet-form-area">
                      <h3 class="wallet-form-hdng">Linking account is a one-time process.</h3>
                      <div class="wallet-form-area">
                        <div class="row wallet-row">
                          <div class="col-12 col-xl-7 wallet-col">
                            <div class="wallet-fld">
                              <input type="text" class="wallet-text-fld" placeholder="Add your email address" />
                            </div>
                          </div>
                          <div class="col-12 col-xl-5 wallet-col">
                            <div class="wallet-phn-fld-area">
                              <select class="wallet-code-drpdwn">
                                <option value="+91">+91</option>
                              </select>
                              <input type="text" class="wallet-text-fld" placeholder="" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> -->

                    <div class="subscrp-pymnt-pnl-actnarea">
                      <button class="pymnt-blue-btn mid-width" [disabled]="!selectedWalletCode && subscriptionbillingUtility.emiPayLaterFulltotalAmount"
                        (click)="payUsingWallet()">Pay <span class="rupee">₹</span>
                        {{paymentType == "fullpayment" ? (subscriptionbillingUtility.fullPaymentOptions?.amount | number : '1.2-2')
                        : (((subscriptionbillingUtility.emiOptions?.length)?(subscriptionbillingUtility.emiOptions[0].amount):0) | number :'1.2-2')}} using Wallet</button>
                    </div>

                  </div>
                </div>
              </div>
              <!-- Wallet panel closed -->

              <!-- EMI panel open -->
              <div *ngIf="customPaymntType =='emi'">
                <div class="subscrp-brdr-frmbx-cntarea">
                  <!-- first EMI panel open -->
                  <div class="subscrp-EMI-panel first-panel" *ngIf="innerPanelName == ''">
                    <h3 class="subscrp-sctn-hdng" (click)="customPaymntPanelClose()">
                      <button class="icn-btn desk-hide"><i class="fa fa-angle-left" aria-hidden="true"></i></button> EMI
                    </h3>
                    <div class="subscrp-blue-brdbox" 
                    *ngIf="(bajajFinanceNoCostEmiData?.showBajaj && bajajFinanceNoCostEmiData?.min_amount<=subscriptionbillingUtility.emiPayLaterFulltotalAmount && subscriptionbillingUtility.emiPayLaterFulltotalAmount<=bajajFinanceNoCostEmiData?.max_amount) || showWalnut369"
                    >
                      <div class="subscrp-blue-brdbox-hdr">
                        <h3 class="subscrp-blue-hdng">Cardless EMI</h3>
                      </div>
                      <ul class="subscrp-nrmal-v-list small-gap">
                        <li *ngIf="bajajFinanceNoCostEmiData?.showBajaj && bajajFinanceNoCostEmiData?.min_amount<=subscriptionbillingUtility.emiPayLaterFulltotalAmount && subscriptionbillingUtility.emiPayLaterFulltotalAmount<=bajajFinanceNoCostEmiData?.max_amount">
                          <div class="subscrp-emi-bank-name-box"
                            (click)="setSelectedbankEMIData('secondEMIPanel', bajajFinanceNoCostEmiData, 'BajajNoCostEMI')"
                          >
                            <h4 class="emi-bank-title">Bajaj Finserv - Cardless</h4>
                            <div class="emi-nocost-tag">No cost EMI</div>
                          </div>
                        </li>
                        <li *ngIf="showWalnut369">
                          <div class="subscrp-emi-bank-name-box"
                            (click)="payUsingWalnut369()"
                          >
                            <h4 class="emi-bank-title">Walnut 369 - Cardless</h4>
                            <div class="emi-nocost-tag">No cost EMI</div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="subscrp-blue-brdbox" *ngIf="hasDebitCardEMI">
                      <div class="subscrp-blue-brdbox-hdr">
                        <h3 class="subscrp-blue-hdng">Debit Card EMI</h3>
                      </div>
                      <ul class="subscrp-nrmal-v-list small-gap">
                        <li *ngFor="let bankDebitCardEmi of validEmiData">
                          <div class="subscrp-emi-bank-name-box" *ngIf="bankDebitCardEmi.mode=='all' || bankDebitCardEmi.mode=='debit'"
                            (click)="setSelectedbankEMIData('secondEMIPanel', bankDebitCardEmi, 'debit')"
                          >
                            <h4 class="emi-bank-title">{{ bankDebitCardEmi.name }} - Debit Card</h4>
                            <span class="emi-nocost-tag" *ngIf="bankDebitCardEmi.isNoCostEMI">No cost EMI</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="subscrp-blue-brdbox" *ngIf="hasCreditCardEMI">
                      <div class="subscrp-blue-brdbox-hdr">
                        <h3 class="subscrp-blue-hdng">Credit Card EMI</h3>
                      </div>
                      <ul class="subscrp-nrmal-v-list small-gap">
                        <li *ngFor="let bankCreditCardEmi of validEmiData">
                          <div class="subscrp-emi-bank-name-box" *ngIf="bankCreditCardEmi.mode=='all' || bankCreditCardEmi.mode=='credit'"
                            (click)="setSelectedbankEMIData('secondEMIPanel', bankCreditCardEmi, 'credit')"
                          >
                            <h4 class="emi-bank-title">{{ bankCreditCardEmi.name }} - Credit Card</h4>
                            <span class="emi-nocost-tag" *ngIf="bankCreditCardEmi.isNoCostEMI">No cost EMI</span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- first EMI panel closed -->

                  <!-- second EMI panel open -->
                  <div class="subscrp-EMI-panel second-panel" *ngIf="innerPanelName == 'secondEMIPanel'">
                    <h3 class="subscrp-sctn-hdng cursor-pointer" (click)="toggleInnerPanel('')">
                      <button class="icn-btn _desk-hide"><i class="fa fa-angle-left"></i></button>
                      {{selected_bank_emi_data.name}} - {{ emiMode=="credit" ? "Credit" : emiMode=="debit" ? "Debit" : "Cardless" }} Card
                    </h3>
                    <div class="subscrp-blue-brdbox" *ngIf="selected_bank_emi_data.isNoCostEMI">
                      <div class="subscrp-blue-brdbox-hdr">
                        <h3 class="subscrp-blue-hdng">No Cost EMI</h3>
                      </div>
                      <ul class="subscrp-nrmal-v-list small-gap">
                        <li *ngFor="let plan of selected_bank_emi_data?.plans; let index=index">
                          <!-- cart value should be grater than plan min amount -->
                          <label class="subscrp-emi-bank-label" *ngIf="plan?.interest == 0 && subscriptionbillingUtility?.fullPaymentOptions?.amount>plan?.min_amount">
                            <input type="radio" class="subscrp-emi-bank-radio" [name]="selected_bank_emi_data?.name" 
                              [checked]="plan?.duration == selectedEmiPlan?.duration && plan?.code == selectedEmiPlan?.code && index == selectedEmiPlan?.index"
                            />
                            <div class="subscrp-emi-bank-name-box flex-column">
                              <div class="emi-bank-name-box-innr">
                                <div class="emi-bank-title-sctn">
                                  <h3 class="emi-bank-price-title">₹{{plan?.amountForMonth | number : '1.2-2'}} <small>per month</small></h3>
                                  <h4 class="emi-bank-title light">{{ plan?.duration }}-months EMI</h4>
                                </div>
                              </div>
                              <div class="emi-details-row">
                                <ul class="emi-price-detl-lst bdr-top">
                                  <li class="emi-price-detl-row">
                                    <div class="emi-detl-col">EMI Value</div>
                                    <div class="emi-detl-col price-col">₹{{this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount | number : '1.2-2'}}</div>
                                  </li>
                                  <li class="emi-price-detl-row" *ngIf="bajajFinanceNoCostEmiData?.code != 'BAJAJ'">
                                    <div class="emi-detl-col">Bank interest charges</div>
                                    <div class="emi-detl-col price-col">₹{{plan?.noCostEmiDiscount | number : '1.2-2'}}</div>
                                  </li>
                                  <li class="emi-price-detl-row" *ngIf="bajajFinanceNoCostEmiData?.code != 'BAJAJ'">
                                    <div class="emi-detl-col blue-text"><b>No cost EMI discount</b></div>
                                    <div class="emi-detl-col blue-text price-col"><b>-₹{{plan?.noCostEmiDiscount | number : '1.2-2'}}</b></div>
                                  </li>
                                </ul>
                                <ul class="emi-price-detl-lst bdr-top">
                                  <li class="emi-price-detl-row">
                                    <div class="emi-detl-col">
                                      <div class="inoneline">Total payable amount 
                                        <div class="CUPFL-c-tooltip" (click)="displayTooltip()"><img src="assets/img/tooltip-info-icon.svg" class="info-tooltipicon" />
                                          <div class="CUPFL-c-tooltip-box" *ngIf="showEmiTooltip || deviceWidth>992">
                                            <button class="CUPFL-c-tooltip-cls"(click)="closeTooltip()">
                                              <img src="assets/img/detail-close-icon.svg" class="cls-icn" />
                                            </button>
                                            <p class="para">Full amount of ₹{{subscriptionbillingUtility?.emiPayLaterFulltotalAmount | number : '1.2-2'}} will be deducted from your account, which will be converted into EMI by your bank in 3-4 days.</p>
                                          </div>
                                        </div>
                                      </div>
                                      <span class="big-price-txt"><span class="rupee">₹</span>
                                          {{subscriptionbillingUtility?.emiPayLaterFulltotalAmount | number : '1.2-2'}}</span>
                                    </div>
                                    <div class="emi-detl-col price-col">
                                      <button class="pymnt-blue-btn sm-btn"
                                        (click)="setSelectedEMIPlan('thirdFormPanel', plan, index)">NEXT</button>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </label>
                        </li>
                      </ul>
                    </div>
                    <div class="subscrp-blue-brdbox mob-no-border" *ngIf="emiMode=='credit' || emiMode=='debit'">
                      <div class="subscrp-blue-brdbox-hdr">
                        <h3 class="subscrp-blue-hdng">EMI with Interest</h3>
                      </div>
                      <ul class="subscrp-nrmal-v-list small-gap">
                        <li *ngFor="let plan of selected_bank_emi_data?.plans; let index=index">
                          <!-- cart value should be grater than plan min amount -->
                          <label class="subscrp-emi-bank-label" *ngIf="plan?.interest != 0 && this.subscriptionbillingUtility?.fullPaymentOptions?.amount>plan?.min_amount">
                            <input type="radio" class="subscrp-emi-bank-radio" [name]="selected_bank_emi_data?.name"
                              [checked]="plan?.duration == selectedEmiPlan?.duration && plan?.code == selectedEmiPlan?.code && index == selectedEmiPlan?.index"
                            />
                            <div class="subscrp-emi-bank-name-box flex-column">
                              <div class="emi-bank-name-box-innr">
                                <div class="emi-bank-title-sctn">
                                  <h3 class="emi-bank-price-title">₹{{plan?.amountForMonth | number : '1.2-2'}} <small>per month</small></h3>
                                  <h4 class="emi-bank-title light">{{ plan?.duration }}-months EMI</h4>
                                </div>
                                <div class="emi-bank-title">@{{ plan?.interest }}% p.a</div>
                              </div>
                              <div class="emi-details-row">
                                <ul class="emi-price-detl-lst bdr-top">
                                  <li class="emi-price-detl-row">
                                    <div class="emi-detl-col">EMI Value</div>
                                    <div class="emi-detl-col price-col">₹{{this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount | number : '1.2-2'}}</div>
                                  </li>
                                  <li class="emi-price-detl-row">
                                    <div class="emi-detl-col">Bank interest charges</div>
                                    <div class="emi-detl-col price-col">₹{{(plan?.amountForMonth*plan?.duration-this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount) | number : '1.2-2'}}</div>
                                  </li>
                                </ul>
                                <ul class="emi-price-detl-lst bdr-top">
                                  <li class="emi-price-detl-row">
                                    <div class="emi-detl-col"><div class="inoneline">Total payable amount 
                                      <div class="CUPFL-c-tooltip" (click)="displayTooltip()"><img src="assets/img/tooltip-info-icon.svg" class="info-tooltipicon" />
                                      <div class="CUPFL-c-tooltip-box" *ngIf="showEmiTooltip || deviceWidth>992">
                                        <button class="CUPFL-c-tooltip-cls"(click)="closeTooltip()">
                                          <img src="assets/img/detail-close-icon.svg" class="cls-icn" />
                                        </button>
                                        <!-- <h2 class="h2-tooltiip-heading">About</h2> -->
                                        <p class="para">Full amount of ₹{{this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount| number : '1.2-2'}} will be deducted from your account, which will be converted into EMI by your bank in 3-4 days.</p>
                                      </div>
                                    </div></div><span
                                        class="big-price-txt"><span class="rupee">₹</span>
                                        {{(plan?.amountForMonth*plan?.duration) | number : '1.2-2'}}</span></div>
                                    <div class="emi-detl-col price-col">
                                      <button class="pymnt-blue-btn sm-btn" 
                                        (click)="setSelectedEMIPlan('thirdFormPanel', plan, index)"
                                      >NEXT</button>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- second EMI panel open -->

                  <!-- EMI form panel open -->
                  <div class="subscrp-EMI-panel third-form-panel" *ngIf="innerPanelName == 'thirdFormPanel'">
                    <h3 class="subscrp-sctn-hdng justify-content-between" (click)="toggleInnerPanel('secondEMIPanel')">
                      <div class="subscrp-hdng-with-arrow"><span class="icn-btn desk-hide"><i class="fa fa-angle-left"></i></span><span>{{selected_bank_emi_data?.name}} - {{
                        emiMode=="credit" ? "Credit" : emiMode=="debit" ? "Debit" : "" }} Card</span></div>
                       <span class="icn-btn mob-hide"><i class="fa fa-angle-up"></i></span>
                    </h3>
                    <div class="subscrp-add-crd-box">
                      <div class="subscrp-add-crd-hdr-area justify-content-between">
                        <h4 class="subscrp-add-crd-hdng mob-view">{{selectedEmiPlan?.duration}} EMIs at ₹{{selectedEmiPlan?.amountForMonth | number : '1.2-2'}}/month</h4>
                        <button class="subscrp-blue-text-btn mob-view" (click)="toggleInnerPanel('secondEMIPanel')">Change Plan</button>
                      </div>
                      <div class="subscrp-form-area" *ngIf="emiMode=='credit' || emiMode=='debit'" [formGroup]="EMICardForm">
                        <div class="subscrp-add-crd-fld-row">
                          <input type="text" class="subscrp-add-crd-fld" placeholder="Name on Card"
                            formControlName='card_placeholder_name'
                            OnlyAlphabetsAndSpace
                            onkeypress="return (event.charCode>= 65 && event.charCode<=90) || (event.charCode>= 97 && event.charCode<=122) || event.charCode==32"
                          />
                          <span *ngIf="EMICardForm?.controls?.card_placeholder_name?.touched">
                            <span class="text-danger error-text"
                              *ngIf="EMICardForm?.controls?.card_placeholder_name?.errors?.required">
                              *Please Enter name
                            </span>
                            <span class="text-danger error-text" *ngIf="EMICardForm?.controls?.card_placeholder_name?.errors?.pattern">
                              *Please Provide correct name
                            </span>
                          </span>
                        </div>
                        <div class="subscrp-add-crd-fld-row">
                          <input type="text" class="subscrp-add-crd-fld" placeholder="Card Number"
                            maxlength="19"
                            formControlName='card_number' onlyNumber />
                          <span *ngIf="EMICardForm?.controls?.card_number?.touched">
                            <span class="text-danger error-text"
                              *ngIf="EMICardForm?.controls?.card_number?.errors?.required">
                              *Please Enter card number
                            </span>
                            <p class="text-danger error-text" *ngIf="EMICardForm?.controls?.card_number?.errors?.pattern">
                              *Please Provide correct card number
                            </p>
                            
                            <span class="text-danger error-text"
                              *ngIf="!EMICardForm?.controls?.card_number?.errors?.required && !EMICardForm?.controls?.card_number?.errors?.pattern && EMICardErrorMSg">
                              *{{EMICardErrorMSg}}
                            </span>
                          </span>
                        </div>
                        <div class="subscrp-add-crd-fld-row">
                          <div class="row custom-row">
                            <div class="col-7 custom-col">
                              <input type="text" class="subscrp-add-crd-fld" placeholder="Expiry Date (MM/YY)"
                                name="expiryAutofillDoesntKnow"
                                autocomplete="noac"
                                formControlName='expiry' maxlength='5'
                                MMYY
                                (keypress)="dateKeyPress($event)"
                                (keyup)="addSlash($event)"
                                (keydown)="removeSlash($event)"
                              />
                              <span *ngIf="EMICardForm?.controls?.expiry?.touched">
                                <span class="text-danger error-text"
                                  *ngIf="EMICardForm?.controls?.expiry?.errors?.required">
                                  *Please Enter expiry date
                                </span>
                                <span class="text-danger error-text"
                                  *ngIf="EMICardForm?.controls?.expiry?.errors?.pattern">
                                  *Please Provide correct expiry date(MM/YY)
                                </span>
                                <span class="text-danger error-text"
                                  *ngIf="!EMICardForm?.controls?.expiry?.errors?.required && !EMICardForm?.controls?.expiry?.errors?.pattern && EMICardForm?.controls?.expiry?.errors?.cardExpiryCheck">
                                  *Card expiry date is over
                                </span>
                              </span>
                            </div>
                            <div class="col-5 custom-col">
                              <input type="password" class="subscrp-add-crd-fld" placeholder="CVV"
                                maxlength='4'
                                name="cvvAutofillDoesntKnow"
                                autocomplete="noac"
                                formControlName='cvv'
                                onkeypress="return event.charCode>= 48 && event.charCode<=57"
                                onlyNumber
                              />
                              <span *ngIf="EMICardForm?.controls?.cvv?.touched">
                                <span class="text-danger error-text" *ngIf="EMICardForm?.controls?.cvv?.errors?.required">
                                  *Please Enter cvv
                                </span>
                                <span class="text-danger error-text" *ngIf="EMICardForm?.controls?.cvv?.errors?.pattern">
                                  *Please Provide correct cvv
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div class="subscrp-add-crd-actn-area">
                          <button class="pymnt-blue-btn full-width" [disabled]="!EMICardForm.valid"
                            (click)="payUsingEMI()">Proceed & pay</button>
                        </div>
                      </div>
                      <div class="subscrp-form-area" *ngIf="emiMode=='BajajNoCostEMI'" [formGroup]="BajajEMICardForm">
                        <div class="subscrp-add-crd-fld-row">
                          <input type="text" class="subscrp-add-crd-fld" placeholder="Card Number / Phone Number"
                            maxlength="19"
                            formControlName='card_number' onlyNumber />
                          <span *ngIf="BajajEMICardForm?.controls?.card_number?.touched">
                            <span class="BajajEMICardForm-danger error-text"
                              *ngIf="BajajEMICardErrorMSg?.controls?.card_number?.errors?.required">
                              *Please Enter card/phone number
                            </span>
                            <p class="text-danger error-text" *ngIf="BajajEMICardForm?.controls?.card_number?.errors?.pattern">
                              *Please Provide correct card/phone number
                            </p>
                            
                            <span class="text-danger error-text"
                              *ngIf="!BajajEMICardForm?.controls?.card_number?.errors?.required && !BajajEMICardForm?.controls?.card_number?.errors?.pattern && BajajEMICardErrorMSg">
                              *{{BajajEMICardErrorMSg}}
                            </span>
                          </span>
                        </div>


                        <div class="subscrp-add-crd-actn-area tpgap-none btmgap text-center" *ngIf="!bajajFinanceNoCostEmiData.isDisplayOtp">
                          <button class="pymnt-blue-btn sm-width outline"
                            [disabled]="BajajEMICardForm?.controls?.card_number?.errors?.required || BajajEMICardForm?.controls?.card_number?.errors?.pattern"
                            (click)="createOrderAndGetOtpWithBajajNoCostEMI()">Generate OTP</button>
                        </div>
                        <div class="generated-otp-section" *ngIf="bajajFinanceNoCostEmiData.isDisplayOtp">
                          <div class="subscrp-add-crd-fld-row">
                            <input type="text" class="subscrp-add-crd-fld" placeholder="Enter OTP"
                              maxlength="6"
                              formControlName='bajajOtp' 
                              onlyNumber 
                            />
                            <span *ngIf="BajajEMICardForm?.controls?.bajajOtp?.touched">
                              <span class="BajajEMICardForm-danger error-text"
                                *ngIf="BajajEMICardErrorMSg?.controls?.card_number?.errors?.required">
                                *Please Enter OTP number
                              </span>
                              <p class="text-danger error-text" *ngIf="BajajEMICardForm?.controls?.bajajOtp?.errors?.pattern">
                                *Please Provide correct OTP number
                              </p>
                              
                              <span class="text-danger error-text"
                                *ngIf="!BajajEMICardForm?.controls?.bajajOtp?.errors?.required && !BajajEMICardForm?.controls?.bajajOtp?.errors?.pattern && BajajEMIOtpErrorMSg">
                                *{{BajajEMIOtpErrorMSg}}
                              </span>
                            </span>
                          </div>
                          <div class="subscrp-add-crd-fld-row" *ngIf="!resendotp">
                            <span class="resend-otp-txt-sctn">
                              Resend OTP in {{ counter }} sec
                            </span>
                          </div>
  
                          <div class="subscrp-add-crd-actn-area tpgap-none btmgap text-center" *ngIf="resendotp">
                            <button class="pymnt-blue-btn sm-width outline" (click)="resendBajajOtp()">Resend OTP</button>
                          </div>
                          <div class="subscrp-add-crd-actn-area tpgap-none text-center">
                            <button class="pymnt-blue-btn full-width" 
                              [disabled]="!BajajEMICardForm.valid"
                              (click)="payUsingBajajNoCostEMI()"
                            >PROCEED & PAY</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- EMI form panel closed -->

                </div>
              </div>
              <!-- EMI panel closed -->

              <!-- Pay in parts panel open -->
              <div *ngIf="customPaymntType =='pay_in_part'">
                <div class="subscrp-brdr-frmbx-cntarea btm-padd-none">
                  <h3 class="subscrp-sctn-hdng" (click)="customPaymntPanelClose()">
                    <button class="icn-btn desk-hide"><i class="fa fa-angle-left" aria-hidden="true"></i></button> Pay
                    in Parts
                  </h3>
                  <p class="partpay-para">Pay your subscription amount in multiple parts with multiple payments options
                  </p>
                </div>
                <!-- part payment section start -->
                <!-- <ul class="slct-paymnt-new-list custom-part-paymnt-flow">
                  <li *ngIf="subscriptionbillingUtility.emiOptions?.length">
                    <div class="slct-billing-box">
                      <div class="pay-in-section">
                        <div class="payin-radio-sctn">
                          <h4 class="payin-title">Pay in :</h4>
                          <div class="radio-box-area">
                            <label class="custom-blu-radio" *ngFor="let partOptions of subscriptionbillingUtility?.partialPayment;let index=index">
                              <input type="radio" name="select-month" (click)="selectedEmiInstalments(partOptions)" [checked]="partOptions?.partPaymentPlanDetailsDto?.length==this.subscriptionbillingUtility.emiOptions.length"/>
                              <div class="radio-cont-area">{{partOptions?.partPaymentPlanDetailsDto?.length}} Parts</div>
                            </label>
                          </div>
                        </div>
                        <h4 class="slct-pymnt-subhdng enroll-now">Enroll now & Pay
                          {{this.subscriptionbillingUtility?.emiPayLaterFulltotalAmount | number : '1.2-2'}} in {{ subscriptionbillingUtility.emiOptions?.length }} parts till {{ lastPartPaymentDate  | date :'d MMMM , y'}}
                          <span
                            *ngIf="subscriptionbillingUtility.emiOptions?.length && subscriptionbillingUtility?.emiOptions[subscriptionbillingUtility.emiOptions?.length -1]">
                            {{subscriptionbillingUtility.emiOptions[subscriptionbillingUtility.emiOptions?.length
                            -1].lastdate | date :'d MMM, y'}}
                          </span>

                        </h4>
                      </div>
                      <div class="partpay-detail-hd-section" (click)="openPartapayBtn()" [ngClass]="openPartapaystatus? 'opened':''">
                        <span>Part Payments Dates & Details :</span>
                        <i class="fa fa-caret-down" aria-hidden="true"></i>
                      </div>
          
                      <div class="slct-billing-detl-area" [ngClass]="openPartapaystatus? 'opened':''">
                        <div class="slct-billing-detl-innr">
                          <ul class="new-cart-prtpymnt-list">
                            <label class="slct-billing-box sub-bill-box">
                              <div class="single-pckage-brckup-area">
                                <h3 class="slct-pymnt-hdng"> {{subscriptionbillingUtility?.selectedPackage?.name}}</h3>
                                <div class="single-pckage-list-area">
                                  <ul class="singlepcage-prtpymnt-list">
                                    <li *ngFor="let paymentOptions of subscriptionbillingUtility.emiOptions;let index=index">
                                      <div class="slct-pymnt-wrap">
                                        <div class="part-prize" *ngIf="index==0">₹ {{paymentOptions?.amount | number : '1.2-2'}}</div>
                                        <div class="part-prize-date" *ngIf="index==0">(to be paid now)</div>
                                        <div class="part-prize" *ngIf="index!=0">₹{{paymentOptions?.amount | number :
                                          '1.2-2'}}</div>
                                        <div class="part-prize-date" *ngIf="index>0">
                                          (to be paid by {{paymentOptions?.lastdate| date :'d MMMM , y'}})
                                        </div>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </label>                        
                          </ul>
                        </div>
                      </div>
                      <div class="slct-pymnt-przcol part-pay">
                        <div class="partpay-lft-col">
                          <div class="final-price-area">
                            <h3 class="slct-pymnt-subhdng">Enroll now at just</h3>
                          <div class="final-price"><span class="rupee">₹</span>
                            <span *ngIf="subscriptionbillingUtility.emiOptions?.length">
                              {{((subscriptionbillingUtility.emiOptions?.length)?(subscriptionbillingUtility.emiOptions[0].amount):0) | number : '1.2-2'}}
                            </span>
                          </div>
                          </div>                          
                        </div>
                        <button class="payment-btn" (click)="doPartPayment()" (click)="payValue((subscriptionbillingUtility.emiOptions?.length)?(subscriptionbillingUtility.emiOptions[0].amount):0,'partpayment')">Pay <span class="rupee">₹</span>{{((subscriptionbillingUtility.emiOptions?.length)?(subscriptionbillingUtility.emiOptions[0].amount):0) | number : '1.2-2'}}
                        </button>
                      </div>
                    </div>
                  </li>
                </ul> -->
                <!-- part payment section ended -->
              </div>
              <!-- Pay in parts panel closed -->

              <!-- Pay later panel open -->
              <div *ngIf="customPaymntType =='pay_later'">
                <div class="subscrp-brdr-frmbx-cntarea">
                  <h3 class="subscrp-sctn-hdng" (click)="customPaymntPanelClose()">
                    <button class="icn-btn desk-hide"><i class="fa fa-angle-left" aria-hidden="true"></i></button> Pay
                    Later
                  </h3>
                  <div class="subscrp-blue-brdbox">
                    <div class="subscrp-blue-brdbox-hdr">
                      <h3 class="subscrp-blue-hdng">Select an option</h3>
                    </div>
                    <ul class="subscrp-nrmal-v-list">
                      <li (click)="payLaterUsingICICI('icic')">
                        <div class="subscrp-blue-bg-brdbox pointer">
                          <div class="subscrp-info-col">
                            <img class="subscrp-blue-icn" src="assets/img/icicibank.png" />
                            <div class="subscrp-bx-info">
                              <h3 class="hdng">ICICI Bank</h3>
                              <h4 class="subhdng">Pay later with ICICI with 0% interest</h4>
                            </div>
                          </div>
                          <div class="subscrp-actn-col">
                            <div class="icn-btn"><i class="fa fa-angle-right icn"></i></div>
                          </div>
                        </div>
                      </li>
                      <li (click)="payUsingSimpl()">
                        <div class="subscrp-blue-bg-brdbox pointer">
                          <div class="subscrp-info-col">
                            <img class="subscrp-blue-icn" src="assets/img/simpl.png" />
                            <div class="subscrp-bx-info">
                              <h3 class="hdng">Simpl</h3>
                              <h4 class="subhdng" *ngIf="simplEligibilityData?.error_code == 'linking_required'">
                                Buy Now Pay Later
                              </h4>
                              <h4 class="subhdng red-text" *ngIf="simplEligibilityData?.error_code == 'linking_required'">
                                Linking Required
                              </h4>
                              <h4 class="subhdng red-text"
                                *ngIf="simplEligibilityData?.error_code == 'insufficient_credit'">
                                Insufficient Credit
                              </h4>
                              <h4 class="subhdng red-text" *ngIf="simplEligibilityData?.error_code == 'pending_dues'">
                                Bill Pending
                              </h4>
                              <h4 class="subhdng red-text" *ngIf="simplEligibilityData?.status == 'not_eligible'">
                                Not eligible
                              </h4>
                            </div>
                          </div>
                          <div class="subscrp-actn-col">
                            <div class="price-box green-text"
                              *ngIf="simplEligibilityData?.error_code == 'insufficient_credit' || simplEligibilityData?.error_code == null">
                              <span>₹</span>{{simplEligibilityData?.available_credit_in_paise/100}}
                            </div>
                            <div class="price-box red-text" *ngIf="simplEligibilityData?.error_code == 'pending_dues'">
                              <span>₹</span>0
                            </div>
                            <div class="icn-btn"><i class="fa fa-angle-right icn"></i></div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- Pay later panel closed -->
            </div>
          </div>
        </div>
        <!-- custom payment flow area closed -->


      </div>
      <div class="col-xl-4 col-lg-5 m-hide right-col">
        <ng-container *ngTemplateOutlet="orderReview_billingSummery_couponCode"></ng-container>
      </div>
      
    </div>
  </div>
  <!-- new flow ended -->
  <ng-template #orderReview_billingSummery_couponCode>
    <div class="SUBCRP-cart-review-box">
      <div class="SUBCRP-cart-review-hdr border-none">
        <h3 class="SUBCRP-cart-review-hdng">Billing Summary</h3>
      </div>
      <div class="SUBCRP-cart-review-cntarea">
        <p class="packName">{{subscriptionbillingUtility?.selectedPackage?.name}}</p>
        <ul class="SUBCRP-cart-review-list">
          <li class="subtotal">
            <span>Subtotal</span>
            <div class="review-bold-text"><span
              class="rupee-txt">₹</span>{{((subscriptionbillingUtility.liveClassbatch?.length>0)?(subscriptionbillingUtility?.emiOptions[0]?.amount):(subscriptionbillingUtility.selectedDuration?.amount)) | number : '1.2-2'}}</div>
          </li>
          <li class="subtotal" *ngIf="subscriptionbillingUtility.discountValid == 'valid'">
            <span>Coupon Code</span>
            <div class="review-bold-text discount-green-text"><span class="rupee-txt">- ₹</span>
              {{subscriptionbillingUtility.discountAmount | number : '1.2-2'}}

              <!-- {{((subscriptionbillingUtility.discountPercentage)) | number :'1.2-2'}} -->
            </div>
          </li>
          <li class="grand-total">
            <span class="review-blue-txt review-bold-text">Grand Total</span>
            <div class="review-blue-txt review-bold-text"><span class="rupee-txt">₹</span>
              {{subscriptionbillingUtility.fullPaymentOptions?.amount | number : '1.2-2'}}
            </div>
          </li>          
        </ul>
      </div>
    </div>
    <div class="cuponcode-row">
      <div class="cuponcode-area">
        <div class="got-cupon-text" *ngIf="!subscriptionbillingUtility.applyCouponHere">Got a Coupon? 
          <button class="got-cupon-text-btn" (click)="subscriptionbillingUtility.applyCouponHere?subscriptionbillingUtility.applyCouponHere=false:subscriptionbillingUtility.applyCouponHere=true">Apply here</button>
        </div>
        <div class="form-area">
          <div class="fld-wrapr" *ngIf="!(subscriptionbillingUtility.discountValid == 'valid') && subscriptionbillingUtility.applyCouponHere">
  
            <input type="text" placeholder="Have a coupon code?" (keydown)="subscriptionbillingUtility.discountValid =''"
              [(ngModel)]="subscriptionbillingUtility.discountCode" (keyup)="couponCheck($event)" />
            <button type="submit" class="cupon-submit-btn" (click)="applyDiscountCode()" [disabled]="!((subscriptionbillingUtility?.discountCode || '').toString().trim()) || couponChecking">Apply</button>
            <label class="error" *ngIf="subscriptionbillingUtility.discountValid == 'error'">This coupon has
              either expired or invalid. Try another one.</label>
          </div>
        
          <div class="cupon-applied" *ngIf="subscriptionbillingUtility.discountValid == 'valid'">
            <div class="title"><img src="assets/img/cuponcode-icon.svg" alt="" /> Coupon ({{subscriptionbillingUtility.discountCode}}) applied.
            </div>
            <button (click)="removeAppliedCode()" class="link">Remove</button>
          </div>
        </div>
      </div>
    </div>

    
  </ng-template>

</div>
</div>

<!-- payment fail Modal starts-->
<div class="modal fade bd-example-modal-lg" id="paymentfail" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel"><strong>Checkout</strong></h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="form-style">
                    <div class="row">
                        <div class="col-md-12 col-lg-12 text-center">
                            <figure class="mb-0">
                                <img src="/assets/img/festival/paycross.png" alt="paycross" class="paycross">
                            </figure>
                            <h5 class="crosspay_title">Your payment could not be completed.</h5>
                        </div>
                    </div>
                   
                    <div class="row">
                        <div class="col-md-12">
                            <div class="trybtn_max">
                                <button type="button" class="cbse-btn" data-toggle="modal"
                                data-target="#jeecrash" (click)="tryagaina()">TRY AGAIN</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- payment fail Modal ends-->

<div class="modal fade bd-example-modal-lg" id="nopackage" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <div class="form-style">
                    <div class="row">
                        <div class="col-md-12 col-lg-12 text-center">
                            <figure class="mb-0">
                                <img src="/assets/img/festival/paycross.png" alt="paycross" class="paycross">
                            </figure>
                            <h5 class="crosspay_title">No Packages are available</h5>
                        </div>
                    </div>
                   
                    <div class="row">
                        <div class="col-md-12">
                            <div class="trybtn_max">
                                <button type="button" class="cbse-btn" data-toggle="modal"
                                data-target="#jeecrash" (click)="noPackage()">Back</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>